// @flow
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import {
  MdEvent,
  MdAdd,
  // MdClose,
} from 'react-icons/lib/md';
import i18n from 'i18n-js';

import InfiniteScroll from 'react-infinite-scroller';
import type { CHANGE_STOP_REQUEST_TYPE } from '../../../types/changeStopRequest';
import * as changeStopRequestActions from '../../../actions/changeStopRequests';
import * as closeableAction from '../../../actions/closeable';
import * as selectors from '../../../reducers';
import CardHeader from '../../CardHeader';
import CardHeaderTitleContainer from '../../CardHeaderTitleContainer';
import CardHeaderTitle from '../../CardHeaderTitle';
import CardHeaderIcon from '../../CardHeaderIcon';
import CardHeaderLeftGroup from '../../CardHeaderLeftGroup';
import CardHeaderRightGroup from '../../CardHeaderRightGroup';
import CardContent from '../../CardContent';
import ChangeStopRequestCard from '../../ChangeStopRequestCard';
import Button from '../../Button';
import Input from '../../Input';
import ButtonGroup from '../../ButtonGroup';
import PlaceholderView from '../../PlaceholderViews';

import styles from './eventsView.css';
import Popup from '../../Popup';
import CreateChangeStopRequestPopupContent from '../../CreateChangeStopRequestPopupContent';
import OpenButton from '../../OpenButton';
import { FullLoader } from '../../Loader';
import SimplePlaceholder from '../../SimplePlaceholder';
import { Loading, NoResults } from '../../CommonTexts';
import PlaceholderImage from '../../../../assets/images/requestph.png';

type EventsViewPropTypes = {
  startFetchChangeStopRequest: Function,
  getRouteStop: Function,
  hasMore: boolean,
  isLoading: boolean,
  updateStateChangeStopRequestStarted: Function,
  open: Function,
  currentState: string,
  changeStopRequests: Array<CHANGE_STOP_REQUEST_TYPE>,
  schoolId: number,
  pending: number,
};

class EventsView extends Component<EventsViewPropTypes> {
  componentWillMount() {
    const { startFetchChangeStopRequest, schoolId } = this.props;
    // if (typeof onLoad !== 'undefined') { onLoad(); }
    startFetchChangeStopRequest(schoolId, { state: 'pending', page: 1 });
  }

  _handleLoadMore(page) {
    const { startFetchChangeStopRequest, schoolId, currentState } = this.props;
    startFetchChangeStopRequest(schoolId, { page, currentState });
  }


  render() {
    const {
      changeStopRequests,
      currentState,
      isLoading,
      hasMore,
      startFetchChangeStopRequest,
      schoolId,
      updateStateChangeStopRequestStarted,
      pending,
    } = this.props;

    return (
      <Fragment>
        <CardHeader size="big">
          <CardHeaderLeftGroup>
            <CardHeaderIcon Icon={MdEvent} />
            <CardHeaderTitleContainer>
              <CardHeaderTitle
                title={i18n.t('common.changeStopRequest', { count: 2 })} />
            </CardHeaderTitleContainer>
          </CardHeaderLeftGroup>
          <CardHeaderRightGroup>
            <OpenButton title={i18n.t('buttons.requestChange')} Icon={MdAdd} id="createChangeStopRequest" clearMargins />
            <Popup
              id="createChangeStopRequest"
              theme="main"
              transitionMs={600}>
              <CreateChangeStopRequestPopupContent />
            </Popup>
          </CardHeaderRightGroup>
        </CardHeader>
        <CardContent className={styles.changeStopRequestCardContent}>

          <div className={styles.changeStopRequestActionBar}>

            <ButtonGroup className={styles.stateButton}>
              <Button
                tint={currentState === 'pending' ? 'primary' : 'mediumGray'}
                title={i18n.t('buttons.pending')}
                isLeft
                onClick={() => startFetchChangeStopRequest(schoolId, { state: 'pending' })}
                clearMargins
              />
              <Button
                title={i18n.t('buttons.solved')}
                tint={currentState === 'approved' ? 'primary' : 'mediumGray'}
                isRight
                onClick={() => startFetchChangeStopRequest(schoolId, { state: 'approved' })}
                clearMargins
              />
            </ButtonGroup>
          </div>
          <div className={styles.changeStopRequestCardsContainer}>
            <InfiniteScroll
              pageStart={1}
              loadMore={this._handleLoadMore.bind(this)}
              hasMore={hasMore}
              loader={
                <FullLoader
                  key={0}
                  tint="mediumGray"
                  title={Loading(i18n.t('common.changeStopRequest', { count: 2 }))}
                />
              }
            >

              {
                isLoading
                && (
                  <FullLoader
                    title={Loading(i18n.t('common.changeStopRequest', { count: 2 }))}
                    key={-1}
                    tint="mediumGray"
                  />
                ) /* : (
                  currentState.length === 0
                  && changeStopRequests.length === 0
                  && <PlaceholderView
                    image={PlaceholderImage}
                    title={NoResults(i18n.t('common.changeStopRequest', { count: 2 }).toLowerCase())}
                    subtitle={i18n.t('common.noCoincidences')}/>
                ) */
              }
              {
                !isLoading
                && changeStopRequests.length === 0
                && <PlaceholderView
                    image={PlaceholderImage}
                    title={NoResults(i18n.t('common.changeStopRequest', { count: 2 }).toLowerCase())}
                    subtitle={i18n.t('common.noCoincidences')}/>
              }
              {
                changeStopRequests.length > 0
                && changeStopRequests.map(request => (
                  <ChangeStopRequestCard
                    key={request.id}
                    id={request.id}
                    changeStopRequest={request}
                    /* approveAction={ updateStateChangeStopRequestStarted(request.id, request.instance_type, 'approved') }
                    rejectAction={ updateStateChangeStopRequestStarted(request.id, request.instance_type, 'rejected') } */
                  />
                ))
              }
            </InfiniteScroll>
          </div>

        </CardContent>
        {/* <ChangeStopRequestCard */}
        {/* fromStop={'Parada 8A'} */}
        {/* toStop={'Parada 7B'} */}
        {/* studentFirstName={'Ruth'} */}
        {/* studentLastName={'Quintana'} */}
        {/* requestedByFirstName={'Cesar'} */}
        {/* requestedByLastName={'Molina'} */}
        {/* studentPicture={'https://edoo-files.s3.amazonaws.com/elvalle/media/cache/05/87/058725397a4aec84173e07279cd419cd.png'} */}
        {/* date={'5/5/2018'} */}
        {/* /> */}
      </Fragment>
    );
  }
}

export default connect(
  (state) => {
    const profile = selectors.getProfileOfType(state, 'admin');
    const currentState = selectors.getStateTypeChangeStopRequests(state);
    return {
      schoolId: profile && profile.school ? profile.school : -1,
      changeStopRequests: selectors.getChangeStopRequests(state, currentState),
      isLoading: selectors.isFetchingChangeStopRequest(state),
      hasMore: selectors.hasMoreChangeStopRequests(state),
      currentState,
      // TODO PABLO: same antipattern of getRoute, please fix it
      getRouteStop(id) { selectors.getRouteStop(state, id); },
    };
  },
  dispatch => ({
    startFetchChangeStopRequest(schoolId: number, filter: Object) {
      dispatch(changeStopRequestActions.startFetchChangeStopRequest(schoolId, filter));
    },
    open: (id: string) => dispatch(closeableAction.open(id)),
    changeFilterChangeStopRequests(stateType: string) {
      dispatch(changeStopRequestActions.changeFilterChangeStopRequests(stateType));
    },
  }),
)(withRouter(EventsView));



// WEBPACK FOOTER //
// ./src/scripts/components/views/BackendEventsView/index.jsx